import { render, staticRenderFns } from "./Cordoalha.vue?vue&type=template&id=666cc397"
import script from "./Cordoalha.vue?vue&type=script&lang=js"
export * from "./Cordoalha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports